import { IPalletShipCommand, PalletShipCommandMode } from "./pallet-ship-command";

export class PalletPickupSlotShippingCommand implements IPalletShipCommand {
    public readonly mode = PalletShipCommandMode.PickupSlot;
    private readonly _palletIdList: string[];
    private readonly _pickupSlotId: string;
    private readonly _sealNumber: string;
    private readonly _comment: string;

    constructor(palletIdList: string[], pickupSlotId: string, sealNumber: string, comment: string) {
        this._palletIdList = palletIdList;
        this._pickupSlotId = pickupSlotId;
        this._sealNumber = sealNumber;
        this._comment = comment;
    }

    get palletIdList() {
        return this._palletIdList;
    }

    get pickupSlotId() {
        return this._pickupSlotId;
    }

    get sealNumber() {
        return this._sealNumber;
    }

    get comment() {
        return this._comment;
    }
}
